/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "./Globals";
import QCache from "./qcache";

let offlineMode = false;
const failureThresh = 3;
const qcache = new QCache();

let failures = 0;

function online() {
    failures = 0;
    offlineMode = false;
}

function offline() {
    failures++;
    if(failures >= failureThresh) {
        offlineMode = true;
    }
}

export function qoffline() {
    return offlineMode;
}

export function qget(loc, successCallback, errorCallback, local) {
    fetch((local ? '' : Globals.serverUrl) + loc, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
    }).then(async (r) => {
        online();
        try {
            var j = await r.json();
            qcache.put(loc, '__NULL__', j);
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        offline();
        qcache.get(loc, '__NULL__', (data) => {
            if(data)
                successCallback?.(data);
            else
                errorCallback?.(data);
        }, () => {
            errorCallback?.(e);
        });
    });
}

export async function qgetAsync(loc) {
    return new Promise((resolve, reject) => {
        fetch(Globals.serverUrl + loc, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        }).then(async (r) => {
            online();
            try {
                var j = await r.json();
                qcache.put(loc, '__NULL__', j);
                resolve(j);
            }
            catch (e) {
                reject(e);
            }
        }, (e) => {
            offline();
            qcache.get(loc, '__NULL__', (data) => {
                if(data)
                    resolve(data);
                else
                    reject(e);
            }, () => {
                reject(e);
            });
        });
    });

}

export function qpost(loc, data, successCallback, errorCallback) {
    fetch(Globals.serverUrl + loc, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(async (r) => {
        online();
        try {
            var j = await r.json();
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        offline();
        if (errorCallback)
            errorCallback(e);
    });
}

export async function qpostAsync(loc, data) {
    return new Promise((resolve, reject) => {
        fetch(Globals.serverUrl + loc, {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }).then(async (r) => {
            online();
            try {
                var j = await r.json();
                resolve(j);
            }
            catch (e) {
                reject(e);
            }
        }, (e) => {
            offline();
            reject(e);
        });
    });
}

export function qpostform(loc, data, successCallback, errorCallback) {
    fetch(Globals.serverUrl + loc, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: data
    }).then(async (r) => {
        online();
        try {
            var j = await r.json();
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        offline();
        if (errorCallback)
            errorCallback(e);
    });
}

export function qpostfd(loc, data, successCallback, errorCallback) {
    fetch(Globals.serverUrl + loc, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: data
    }).then(async (r) => {
        online();
        try {
            var j = await r.json();
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        offline();
        if (errorCallback)
            errorCallback(e);
    });
}

export const qreq = {
    get: qget,
    post: qpost,
    postfd: qpostfd,
    getAsync: qgetAsync,
    postAsync: qpostAsync,
    postform: qpostform
};

